// extracted by mini-css-extract-plugin
export default {"cta":"mG-z","disabled":"nG-z"};